<template>
  <el-container style="margin: 1rem; background-color: #fff;
    padding: 10px; padding-top: 20px; border-radius: 4px; height: calc(100vh - 2rem)">
    <div style="width: 42%; margin: 0 10px;">
      <div style="display: flex; align-items: center; margin-bottom: 5px;">
        <span style="font-size: 18px; font-weight: bold">输入区域</span>
        <el-link type="primary" @click="addDemo()" :underline="false" style="font-size: 18px;">
          （点击插入示例）
        </el-link>
      </div>
      <div>
        <textarea class="user-textarea-01" v-if="showTextarea" id="textQuestions" rows="27"
          style="white-space:pre-wrap;" @keyup="refresh"></textarea>
      </div>
      <br>
      <div style="text-align:center">
        <el-button style="width:200px" type="primary" @click="refresh">预&emsp;览</el-button>
      </div>
    </div>
    <el-dialog title="异常题目" :visible.sync="showError" :append-to-body="true" width="70%" center>
      <div>
        <div v-for="(error,k) in errorList" :key="k" style="margin-bottom: 20px;">
          <div style="margin-bottom: 5px;">
            <pre v-text="error.stText"></pre>
          </div>
          <div>
            <span style="color:red" v-text="error.error"></span>
          </div>
        </div>
      </div>
    </el-dialog>
    <div style="width: 55%; margin-left: auto;">
      <div>
        <span style="font-size: 18px; line-height: 1.5em; font-weight: bold">
          预览区域 共<span style="color:blue">{{questionsList.length}}</span>道题
        </span>
        <span v-if="errorList && errorList.length > 0" style="margin-left:10px; font-size: 12px; line-height: 1.5em; font-weight: bold">
          (另外有<span style="font-size: 15px; color:red;">{{errorList.length}}</span>道题存在异常被剔除，<a style="color:red" href="javascript:void(0)" @click="showError = true ">点击查看详情</a>)
        </span>
        <!-- <div style="height: 35px; display: flex; align-items: center;">
          试题所属标签：{{ $route.query.tags }}
        </div> -->
        <div style="display: flex; align-items: center; padding-bottom: 10px;  border-bottom: 1px solid #DCDFE6;">
          <span>补充试题分类<span style="color: transparent;">x</span></span>
          <!-- <el-select ref="allSelect" v-model="flObj.flbh" style="width:200px" placeholder="请选择试题分类" size="mini">
            <el-option key="flbh" :value="flObj.flbh" :label="flObj.flmc" style="height: auto">
              <classifyTree :value.sync="flObj" type="questions" @click="blurSelect('allSelect')"></classifyTree>
            </el-option>
          </el-select> -->
          <classify :value.sync="flObj.flbh" type="questions"
            style="width:200px" placeholder="请选择试题分类"
            size="mini"
          >
          </classify>
          <span style="color: transparent;">Xx</span>
          <span>补充空白难度<span style="color: transparent;">x</span></span>
          <el-select v-model="defaultNycd" style="width:120px" placeholder="填充空白难度" size="mini">
            <el-option value="1" label="简单"></el-option>
            <el-option value="2" label="普通"></el-option>
            <el-option value="3" label="困难"></el-option>
          </el-select>
          <el-button style="margin-left: auto;"
            type="primary" :disabled="disabled" @click="submit">
              保存试题，并关闭
          </el-button>
        </div>
      </div>

      <div style="overflow: auto; height: calc(100% - 103px)">
        <el-row v-for="(st, stIdx) in questionsList" :key="stIdx" style="padding-bottom: 20px;">
          <el-row style="padding: 10px 0px;">
            <el-col :span="16">
              <pre>{{stIdx + 1}}.{{st.tg}}</pre>
            </el-col>
            <el-col :span="8" style="text-align: right; padding-right: 10px">
              <!-- <el-select ref="stSelect" v-model="st.flObj.flbh" style="width:130px" placeholder="请选择试题分类" size="mini">
                <el-option key="flbh" :value="st.flObj.flbh" :label="st.flObj.flmc" style="height: auto">
                  <classifyTree :value.sync="st.flObj" type="questions" @click="blurSelect('stSelect', stIdx)"></classifyTree>
                </el-option>
              </el-select> -->

              <classify :value.sync="st.flObj.flbh" type="questions"
                style="width:130px" placeholder="请选择试题分类"
                size="mini"
              >
              </classify>

              &nbsp;
              <el-select v-model="st.nycd" style="width: 90px" size="mini">
                <el-option label="简单" value="1"></el-option>
                <el-option label="普通" value="2"></el-option>
                <el-option label="困难" value="3"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <!--单选题 -->
          <el-row v-if="st.tx === '1'">
            <el-radio-group v-model="st.ksyStkStda.ksda" >
              <el-radio onclick="return false" v-for="(stxx, stxxIdx) in st.ksyStkStxxList" :key="stxxIdx" :label="stxx.xxid + ''" style="display: block; width: 200px; margin-bottom: 15px">{{options[stxxIdx]}}.{{stxx.xxsm}}</el-radio>
            </el-radio-group>
          </el-row>
          <!--多选题 -->
          <el-row v-if="st.tx === '2'">
            <el-checkbox-group v-model="st.ksyStkStda.ksda">
              <el-checkbox onclick="return false" v-for="(stxx, stxxIdx) in st.ksyStkStxxList" :key="stxxIdx" :label="stxx.xxid + ''" style="display: block; width: 200px; margin-bottom: 15px">{{options[stxxIdx]}}.{{stxx.xxsm}}</el-checkbox>
            </el-checkbox-group>
          </el-row>
          <!--填空题 -->
          <el-row v-if="st.tx === '3'">
            <el-input v-for="(da, index) in st.ksyStkStda.ksda" :key="index" :placeholder="'请输入第'+(index + 1)+'个填空项'" style="width: 400px; padding: 5px; display: block"></el-input>
          </el-row>
          <!--判断题 -->
          <el-row v-if="st.tx === '4'">
            <el-radio-group v-model="st.ksyStkStda.ksda">
              <el-radio onclick="return false" v-for="(ksyStkStxx, stxxIdx) in st.ksyStkStxxList" :key="stxxIdx" :label="ksyStkStxx.xxid + ''" style="display: block; width: 200px; margin-bottom: 15px">{{ksyStkStxx.xxsm}}</el-radio>
            </el-radio-group>
          </el-row>
          <!--问答题 -->
          <el-row v-if="st.tx === '5'">
            <el-input type="textarea" style="width:400px" :rows="5" placeholder=""></el-input>
          </el-row>
          <div style="font-size: 14px">
            <el-row v-if="st.tx === '1' || st.tx === '2'"><span style="font-weight: bold">答案：</span>{{parseABC(st.ksyStkStda.bzda, st.ksyStkStxxList)}}</el-row>
            <el-row v-if="st.tx === '3'">
              <el-col style="width: 43px"><span style="font-weight: bold">答案：</span></el-col>
              <el-col :span="20">
                <span v-html="st.ksyStkStda.bzda.split('€').join('<br/>')"></span>
              </el-col>
            </el-row>
            <el-row v-if="st.tx === '4'"><span style="font-weight: bold">答案：</span>{{parseXxsm(st.ksyStkStda.bzda, st.ksyStkStxxList)}}</el-row>
            <el-row v-if="st.tx === '5'"><span style="font-weight: bold">答案：</span><pre>{{st.ksyStkStda.bzda}}</pre></el-row>
            <el-row><span style="font-weight: bold">解析：</span><pre>{{st.ksyStkStda.dajx}}</pre></el-row>
            <el-row><span style="font-weight: bold">难度：</span>{{nycdOBj[st.nycd]}}</el-row>
          </div>
        </el-row>
      </div>
    </div>
  </el-container>
</template>

<script>
import { saveBatch } from '@/api/questions'
import classify from '@/components/select/classify'
// 转义 HTML，对于引号，尖括号，斜杠进行转义
const format = function (str) {
  str = str.replace(/&/g, '&amp;')
  str = str.replace(/</g, '&lt;')
  str = str.replace(/>/g, '&gt;')
  // str = str.replace(/"/g, '&quto;')
  // str = str.replace(/'/g, '&#39;')
  // str = str.replace(/`/g, '&#96;')
  // str = str.replace(/\//g, '&#x2F;')
  return str
}
export default {
  name: 'textAdd',
  data () {
    return {
      showTextarea: true,

      defaultNycd: null, // 默认的难易程度
      nycdNullList: [], // 难易程度为空
      disabled: false,
      errorList: [],
      showError: false,

      options: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      nycdOBj: { 1: '简单', 2: '普通', 3: '困难' },
      flObj: {},
      // 试题列表
      questionsList: [],
      // 题目换行符，必须敲两个回车及以上
      enterRegex_tm: /(?:\r|\n){2,}/g,
      // 选项换行符，必须是一个回车
      // enterRegex_xx: /(?:\r|\n){1}/,
      // 用来替换的换行符
      // enterRStr: '@!@',
      // 单选题
      radioRegex: /^(?:\s*[1-9]{1,2}\d*[.。、．])?([\S\s]+)(\[|【)单选题(\]|】)\s*(?=\r|\n)/g,
      // 多选题
      checkboxRegex: /^(?:\s*[1-9]{1,2}\d*[.。、．])?([\S\s]+)(\[|【)多选题(\]|】)\s*(?=\r|\n)/g,
      // 填空题
      inputRegex: /^(?:\s*[1-9]{1,2}\d*[.。、．])?([\S\s]+)(\[|【)填空题(\]|】)\s*(?=\r|\n)/g,
      // 判断题
      judgeRegex: /^(?:\s*[1-9]{1,2}\d*[.。、．])?([\S\s]+)(\[|【)判断题(\]|】)\s*(?=\r|\n)/g,
      // 简答题
      textareaRegex: /^(?:\s*[1-9]{1,2}\d*[.。、．])?([\S\s]+)(\[|【)简答题(\]|】)\s*(?=\r|\n)/g,
      // 选项
      // xxRegex: /(?:\b\s*([A-Za-z])[.。、．]\s*)([\S\s]+?)(?=\n[A-Za-z][.。、．]|\n解析|\n答案|\n难度|\n分类|$)/g,
      xxRegex: /(?:\n([A-Za-z])[.。、．]\s*)([\S\s]+?)(?=\n[A-Za-z][.。、．]|\n解析|\n答案|\n难度|\n分类|$)/g,
      // 答案 +? 非贪婪匹配 最短匹配
      daRegex: /(?:\B\s*(?:答案|标准答案)[:|：])([\S\s]+?)(?=\n解析|\n答案|\n难度|\n分类|$)/,
      // 难度 +? 非贪婪匹配 最短匹配
      ndRegex: /(?:\B\s*(?:难度|题目难度)[:|：])([\S\s]+?)(?=\n解析|\n答案|\n难度|\n分类|$)/,
      // 答案解析 +? 非贪婪匹配 最短匹配
      dajxRegex: /(?:\B\s*(?:解析|答案解析)[:|：])([\S\s]+?)(?=\n解析|\n答案|\n难度|\n分类|$)/,
      // 未知题目
      // tmRegex: /^([\S\s]+)(?:\n\s*(?:答案|标准答案)[:|：])([\S\s]+?)(?=\n解析|\n答案|\n难度|\n分类|$)/,
      tmRegex: /^([\S\s]*?)(?:\n?\s*(?:答案|标准答案)[:：])([\S\s]+?)(?=\n解析|\n答案|\n难度|\n分类|$)/,
      // 选择题题干
      xzttgRegex: /^(?:\s*[1-9]{1,2}\d*[.。、．])?([\S\s]+?)(?=\n[A-Za-z][.。、．])/,
      // 其它题干
      qttgRegex: /^(?:\s*[1-9]{1,2}\d*[.。、．])?([\S\s]+?)(?=\n解析|\n答案|\n难度|\n分类|$)/
    }
  },
  watch: {
    flObj (val, oldVal) {
      this.questionsList.forEach(questions => {
        questions.flObj = questions.flObj.flbh ? questions.flObj : val
      })
    },
    defaultNycd (val, oldVal) {
      // 给题目的难易程度赋值
      this.nycdNullList.forEach((questions, index) => {
        questions.nycd = val
      })
    }
  },
  components: {
    classify
  },
  methods: {
    blurSelect (refNmae, index) {
      if (index !== undefined) {
        this.$refs[refNmae][index].blur()
      } else {
        this.$refs[refNmae].blur()
      }
    },
    refresh () {
      this.questionsList = []
      this.errorList = []
      // 解析文本 并生成试题
      this.getQuestionsByText()
      // 找出没有难易程度的题目
      this.nycdNullList = this.questionsList.filter(questions => questions.nycd == null)
      // 给题目的难易程度赋值
      this.nycdNullList.forEach(questions => {
        questions.nycd = this.defaultNycd
      })
      // console.log(this.questionsList)
    },
    // 将标准答案 转换成 ABC
    parseABC (da, xxList) {
      if (!da) {
        return ''
      }
      if (!Array.isArray(da)) {
        da = da.split('€')
      }
      return da.map(xxid => {
        const xx = xxList.find(xxObj => Number(xxObj.xxid) === Number(xxid))
        return xx ? this.options[xx.xsxh - 1] : ''
      }).join(',')
    },
    parseXxsm (bzda, xxList) {
      const xx = xxList.find(xxObj => Number(xxObj.xxid) === Number(bzda))
      return xx ? xx.xxsm : ''
    },
    // 抽取 难易程度
    getNycd (nycd) {
      if (nycd === '简单' || nycd === '容易') {
        nycd = '1'
      } else if (nycd === '普通' || nycd === '一般') {
        nycd = '2'
      } else if (nycd === '困难' || nycd === '复杂') {
        nycd = '3'
      } else {
        nycd = '1'
      }
      return nycd
    },
    // 单选题
    addRadio (stText, tg, stContent) {
      let nycd = null
      const ksyStkStxxList = []
      const ksyStkStda = {}
      // 标准答案
      if (this.daRegex.test(stContent)) {
        const bzdaUpper = stContent.match(this.daRegex)[1].trim().toUpperCase()
        const bzda = this.options.indexOf(bzdaUpper)
        ksyStkStda.bzda = bzda !== -1 ? bzda + 1 + '' : null
        ksyStkStda.ksda = ksyStkStda.bzda
      }
      // 答案解析
      if (this.dajxRegex.test(stContent)) {
        ksyStkStda.dajx = stContent.match(this.dajxRegex)[1]
      }
      // 难度
      if (this.ndRegex.test(stContent)) {
        nycd = stContent.match(this.ndRegex)[1]
        nycd = this.getNycd(nycd)
      }
      // 选项
      if (this.xxRegex.test(stContent)) {
        this.xxRegex.lastIndex = 0
        let xxResult = this.xxRegex.exec(stContent)
        let i = 0
        while (xxResult !== null) {
          const xxidUpper = xxResult[1].toUpperCase()
          const xxid = this.options.indexOf(xxidUpper)
          const xxsm = xxResult[2]
          const ksyStkStxx = {
            xxid: xxid === -1 ? xxid : xxid + 1,
            xxsm: xxsm,
            xxnr: null,
            xsxh: ++i,
            sfdaxx: ksyStkStda.bzda != null && Number(ksyStkStda.bzda) === xxid + 1 ? '1' : '0'
          }
          ksyStkStxxList.push(ksyStkStxx)
          xxResult = this.xxRegex.exec(stContent)
        }
      }
      // 判断选项ID是否重复
      const xxidList = [...new Set(ksyStkStxxList.map(a => a.xxid))]
      // 如果有选项 有答案 则是个合法的题目
      if (ksyStkStxxList.length > 0 && xxidList.length === ksyStkStxxList.length && ksyStkStda.bzda) {
        // 如果试题选项的ID没有被初始化 则重新生成
        if (ksyStkStxxList.find(stxx => stxx.xxid === -1)) {
          ksyStkStxxList.forEach((stxx, stIdx) => {
            stxx.xxid = stIdx + 1
          })
        }
        const questions = {
          flbh: null,
          tg: tg,
          stnr: null,
          tx: '1',
          nycd: nycd,
          stbb: 1,
          xtgs: 0,
          ksyStkStxxList: ksyStkStxxList,
          ksyStkStda: ksyStkStda
        }
        questions.flObj = {} // 虚构一个分类对象
        this.questionsList.push(questions)
      } else {
        if (ksyStkStxxList.length === 0) {
          console.log('单选题必须有选项')
          this.errorList.push({ stText: stText, error: '单选题必须有选项' })
        } else if (xxidList.length !== ksyStkStxxList.length) {
          console.log('单选题的选项不能重复')
          this.errorList.push({ stText: stText, error: '单选题的选项不能重复' })
        } else if (!ksyStkStda.bzda) {
          console.log('单选题必须有答案')
          this.errorList.push({ stText: stText, error: '单选题必须有答案' })
        }
      }
    },
    // 多选题
    addCheckBox (stText, tg, stContent) {
      let nycd = null
      const ksyStkStxxList = []
      const ksyStkStda = {}
      // 标准答案
      if (this.daRegex.test(stContent)) {
        const bzdaUpper = stContent.match(this.daRegex)[1].trim().toUpperCase()
        const bzda = bzdaUpper
          .split('')
          .map(a => this.options.indexOf(a) + 1)
          .filter(a => a !== 0)
          .join('€')
        ksyStkStda.bzda = bzda !== '' ? bzda : null
        ksyStkStda.ksda = ksyStkStda.bzda.split('€')
      }
      // 答案解析
      if (this.dajxRegex.test(stContent)) {
        ksyStkStda.dajx = stContent.match(this.dajxRegex)[1]
      }
      // 难度
      if (this.ndRegex.test(stContent)) {
        nycd = stContent.match(this.ndRegex)[1]
        nycd = this.getNycd(nycd)
      }
      // 选项
      if (this.xxRegex.test(stContent)) {
        this.xxRegex.lastIndex = 0
        let xxResult = this.xxRegex.exec(stContent)
        let i = 0
        while (xxResult !== null) {
          const xxidUpper = xxResult[1].toUpperCase()
          const xxid = this.options.indexOf(xxidUpper)
          const xxsm = xxResult[2]
          const ksyStkStxx = {
            xxid: xxid === -1 ? xxid : xxid + 1,
            xxsm: xxsm,
            xxnr: null,
            xsxh: ++i,
            sfdaxx: ksyStkStda.bzda != null && ksyStkStda.bzda.indexOf(xxid + 1 + '') > -1 ? '1' : '0'
          }
          ksyStkStxxList.push(ksyStkStxx)
          xxResult = this.xxRegex.exec(stContent)
        }
      }
      // 判断选项ID是否重复
      const xxidList = [...new Set(ksyStkStxxList.map(a => a.xxid))]
      // 如果有选项 有答案 则是个合法的题目
      if (ksyStkStxxList.length > 0 && xxidList.length === ksyStkStxxList.length && ksyStkStda.bzda) {
        // 如果试题选项的ID没有被初始化 则重新生成
        if (ksyStkStxxList.find(stxx => stxx.xxid === -1)) {
          ksyStkStxxList.forEach((stxx, stIdx) => {
            stxx.xxid = stIdx + 1
          })
        }
        const questions = {
          flbh: null,
          tg: tg,
          stnr: null,
          tx: '2',
          nycd: nycd,
          stbb: 1,
          xtgs: 0,
          ksyStkStxxList: ksyStkStxxList,
          ksyStkStda: ksyStkStda
        }
        questions.flObj = {} // 虚构一个分类对象
        this.questionsList.push(questions)
      } else {
        if (ksyStkStxxList.length === 0) {
          console.log('多选题必须有选项')
          this.errorList.push({ stText: stText, error: '多选题必须有选项' })
        } else if (xxidList.length !== ksyStkStxxList.length) {
          console.log('多选题的选项不能重复')
          this.errorList.push({ stText: stText, error: '多选题的选项不能重复' })
        } else if (!ksyStkStda.bzda) {
          console.log('多选题必须有答案')
          this.errorList.push({ stText: stText, error: '多选题必须有答案' })
        }
      }
    },
    // 填空题
    addInput (stText, tg, stContent) {
      let nycd = null
      const ksyStkStxxList = []
      const ksyStkStda = {}
      // 标准答案
      if (this.daRegex.test(stContent)) {
        const bzdaUpper = stContent.match(this.daRegex)[1].trim()
        const bzda = bzdaUpper
          .split(/,|，|、/g)
          .join('€')
        ksyStkStda.bzda = bzda !== '' ? bzda : null
        ksyStkStda.ksda = ksyStkStda.bzda.split('€')
      }
      // 答案解析
      if (this.dajxRegex.test(stContent)) {
        ksyStkStda.dajx = stContent.match(this.dajxRegex)[1]
      }
      // 难度
      if (this.ndRegex.test(stContent)) {
        nycd = stContent.match(this.ndRegex)[1]
        nycd = this.getNycd(nycd)
      }
      // 如果有选项 有答案 则是个合法的题目
      if (ksyStkStda.bzda) {
        const questions = {
          flbh: null,
          tg: tg,
          stnr: null,
          tx: '3',
          nycd: nycd,
          stbb: 1,
          xtgs: 0,
          ksyStkStxxList: ksyStkStxxList,
          ksyStkStda: ksyStkStda
        }
        questions.flObj = {} // 虚构一个分类对象
        this.questionsList.push(questions)
      } else {
        if (!ksyStkStda.bzda) {
          console.log('填空题必须有答案')
          this.errorList.push({ stText: stText, error: '填空题必须有答案' })
        }
      }
    },
    // 判断题
    addJudge (stText, tg, stContent) {
      let nycd = null
      const ksyStkStda = {}
      const ksyStkStxxList = [
        { xxid: 1, xxsm: '正确', xxnr: '正确', xsxh: 1, sfdaxx: '0' },
        { xxid: 2, xxsm: '错误', xxnr: '错误', xsxh: 2, sfdaxx: '0' }
      ]
      // 标准答案
      if (this.daRegex.test(stContent)) {
        const bzdaUpper = stContent.match(this.daRegex)[1].trim()
        const right = /^(?:正确|对|是)$/
        const error = /^(?:错误|错|不对|不是)$/
        let bzda = null
        if (right.test(bzdaUpper)) {
          bzda = '1'
          ksyStkStxxList[0].sfdaxx = '1'
        } else if (error.test(bzdaUpper)) {
          bzda = '2'
          ksyStkStxxList[1].sfdaxx = '1'
        }
        ksyStkStda.bzda = bzda
        ksyStkStda.ksda = ksyStkStda.bzda
      }
      // 答案解析
      if (this.dajxRegex.test(stContent)) {
        ksyStkStda.dajx = stContent.match(this.dajxRegex)[1]
      }
      // 难度
      if (this.ndRegex.test(stContent)) {
        nycd = stContent.match(this.ndRegex)[1]
        nycd = this.getNycd(nycd)
      }
      // 如果有选项 有答案 则是个合法的题目
      if (ksyStkStda.bzda) {
        const questions = {
          flbh: null,
          tg: tg,
          stnr: null,
          tx: '4',
          nycd: nycd,
          stbb: 1,
          xtgs: 0,
          ksyStkStxxList: ksyStkStxxList,
          ksyStkStda: ksyStkStda
        }
        questions.flObj = {} // 虚构一个分类对象
        this.questionsList.push(questions)
      } else {
        if (!ksyStkStda.bzda) {
          console.log('判断题必须有答案')
          this.errorList.push({ stText: stText, error: '判断题必须有答案' })
        }
      }
    },
    // 简答题
    addTextarea (stText, tg, stContent) {
      let nycd = null
      const ksyStkStda = {}
      // 标准答案
      if (this.daRegex.test(stContent)) {
        const bzdaUpper = stContent.match(this.daRegex)[1].trim()
        const bzda = bzdaUpper
        ksyStkStda.bzda = bzda !== '' ? bzda : null
        ksyStkStda.ksda = ksyStkStda.bzda
      }
      // 答案解析
      if (this.dajxRegex.test(stContent)) {
        ksyStkStda.dajx = stContent.match(this.dajxRegex)[1]
      }
      // 难度
      if (this.ndRegex.test(stContent)) {
        nycd = stContent.match(this.ndRegex)[1].trim()
        nycd = this.getNycd(nycd)
      }
      // 如果有选项 有答案 则是个合法的题目
      if (ksyStkStda.bzda) {
        const questions = {
          flbh: null,
          tg: tg,
          stnr: null,
          tx: '5',
          nycd: nycd,
          stbb: 1,
          xtgs: 0,
          ksyStkStda: ksyStkStda
        }
        questions.flObj = {} // 虚构一个分类对象
        this.questionsList.push(questions)
      } else {
        if (!ksyStkStda.bzda) {
          console.log('简答题必须有答案')
          this.errorList.push({ stText: stText, error: '简答题必须有答案' })
        }
      }
    },
    // 通过正则抽取文本
    getQuestionsByText () {
      const textQuestions = document.getElementById('textQuestions').value
      // 根据换行符 分割题目
      let queItemList = textQuestions.split(this.enterRegex_tm)
      // 过滤空值
      queItemList = queItemList.filter(value => {
        return value !== ''
      })
      if (queItemList.length > 0) {
        for (let i = 0; i < queItemList.length; i++) {
          // 初始化正则匹配起始位置
          this.radioRegex.lastIndex = 0
          this.checkboxRegex.lastIndex = 0
          this.inputRegex.lastIndex = 0
          this.judgeRegex.lastIndex = 0
          this.textareaRegex.lastIndex = 0
          this.xxRegex.lastIndex = 0
          const stText = queItemList[i]
          if (this.radioRegex.test(stText)) { // 单选题
            console.log('这是个单选题')
            this.radioRegex.lastIndex = 0
            const tg = this.radioRegex.exec(stText)[1]
            const lastIndex = this.radioRegex.lastIndex
            const stContent = stText.substring(lastIndex + 1, stText.length)
            this.addRadio(stText, tg, stContent)
          } else if (this.checkboxRegex.test(stText)) { // 多选题
            console.log('这是个多选题')
            this.checkboxRegex.lastIndex = 0
            const tg = this.checkboxRegex.exec(stText)[1]
            const lastIndex = this.checkboxRegex.lastIndex
            const stContent = stText.substring(lastIndex + 1, stText.length)
            this.addCheckBox(stText, tg, stContent)
          } else if (this.inputRegex.test(stText)) { // 填空题
            console.log('这是个填空题')
            this.inputRegex.lastIndex = 0
            const tg = this.inputRegex.exec(stText)[1]
            const lastIndex = this.inputRegex.lastIndex
            const stContent = stText.substring(lastIndex + 1, stText.length)
            this.addInput(stText, tg, stContent)
          } else if (this.judgeRegex.test(stText)) { // 判断题
            console.log('这是个判断题')
            this.judgeRegex.lastIndex = 0
            const tg = this.judgeRegex.exec(stText)[1]
            const lastIndex = this.judgeRegex.lastIndex
            const stContent = stText.substring(lastIndex + 1, stText.length)
            this.addJudge(stText, tg, stContent)
          } else if (this.textareaRegex.test(stText)) { // 简答题
            console.log('这是个简答题')
            this.textareaRegex.lastIndex = 0
            const tg = this.textareaRegex.exec(stText)[1]
            const lastIndex = this.textareaRegex.lastIndex
            const stContent = stText.substring(lastIndex + 1, stText.length)
            this.addTextarea(stText, tg, stContent)
          } else {
            // 如果没有标记题型
            console.log('这是个未知题型')
            if (this.tmRegex.test(stText)) {
              const tm = stText.match(this.tmRegex)[1]
              const da = stText.match(this.tmRegex)[2].trim()
              const xzt = /^[a-zA-Z]+$/
              const pdt = /^(?:正确|错误|错|是|不是|对|不对)$/
              const tkt = /^[\S\s]*[(（)][ ,，_]*[)）)]|(?<!_)(?:_{5})(?!_)[\S\s]*$/
              // 如果全是字母，则是选择题
              if (xzt.test(da)) {
                if (tm.match(this.xzttgRegex)) {
                  const tg = tm.match(this.xzttgRegex)[1]
                  if (da.length === 1) {
                    this.addRadio(stText, tg, stText)
                  } else {
                    this.addCheckBox(stText, tg, stText)
                  }
                  continue // 注意这里 只有题目有选项时 才跳出，没有选项则会继续执行
                }
              } else if (pdt.test(da)) { // 如果包含正确错误等，则是判断题
                if (tm.match(this.qttgRegex)) {
                  const tg = tm.match(this.qttgRegex)[1]
                  this.addJudge(stText, tg, stText)
                }
                continue
              }
              // 如果有括号、空格，则是填空题
              if (tkt.test(tm)) {
                if (tm.match(this.qttgRegex)) {
                  const tg = tm.match(this.qttgRegex)[1]
                  this.addInput(stText, tg, stText)
                }
              } else {
                if (tm.match(this.qttgRegex)) {
                  const tg = tm.match(this.qttgRegex)[1]
                  this.addTextarea(stText, tg, stText)
                }
              }
            } else {
              console.log('题目没有配置答案')
              this.errorList.push({ stText: stText, error: '题目没有配置答案' })
            }
          }
        }
      }
    },
    // 格式化对象
    newFormatObj (obj, newObj = {}) {
      if (obj !== null) {
        for (const key in obj) {
          if (obj[key] !== null && typeof obj[key] === 'object') {
            newObj[key] = (obj[key].constructor === Array) ? [] : {}
            this.newFormatObj(obj[key], newObj[key])
          } else {
            // 题干、选项描述、标准答案、答案解析
            if (['tg', 'xxsm', 'bzda', 'dajx'].indexOf(key) !== -1) {
              newObj[key] = format(obj[key])
            } else {
              newObj[key] = obj[key]
            }
          }
        }
      } else {
        return null
      }
      return newObj
    },
    submit () {
      if (this.questionsList.find(questionsL => !questionsL.nycd || !questionsL.flObj.flbh)) {
        this.$message.warning('请完善题目的分类、难度信息')
        return
      }
      if (this.questionsList.length === 0) {
        this.$message.warning('还没有生成试题')
        return
      }
      this.disabled = true
      // 设置试题分类
      this.questionsList.forEach(questionsL => {
        questionsL.flbh = questionsL.flObj.flbh
      })
      this.$confirm('确定完成编辑吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = { list: this.questionsList }
        // 格式化html标签
        params = this.newFormatObj(params)
        saveBatch(params).then(res => {
          this.$http.callback(res, () => {
            this.$message.success(res.msg)
            setTimeout(() => {
              window.close()
            }, 1000)
          })
        })
      }).catch(() => {
        this.disabled = false
      })
    },
    demo () {
      let iinitVal = ''
      iinitVal += '1.这是【单选题】的示例，请选择() &#10;'
      iinitVal += 'A. 选项一 &#10;'
      iinitVal += 'B. 选项二 &#10;'
      iinitVal += 'C. 选项三 &#10;'
      iinitVal += 'D. 选项四 &#10;'
      iinitVal += '答案：A &#10;'
      iinitVal += '难度：简单 &#10;'
      iinitVal += '解析：&#10;'
      iinitVal += '规则一.题干有字母（ABC...）开头的选项 &#10;'
      iinitVal += '规则二.答案只有一个字母 &#10;'
      iinitVal += '&#10;'
      iinitVal += '2.这是【多选题】的示例，请选择() &#10;'
      iinitVal += 'A. 选项一 &#10;'
      iinitVal += 'B. 选项二 &#10;'
      iinitVal += 'C. 选项三 &#10;'
      iinitVal += 'D. 选项四 &#10;'
      iinitVal += '答案：CD &#10;'
      iinitVal += '难度：简单 &#10;'
      iinitVal += '解析：&#10;'
      iinitVal += '规则一.题干有字母（ABC...）开头的选项 &#10;'
      iinitVal += '规则二.答案有多个字母 &#10;'
      iinitVal += '&#10;'
      iinitVal += '2.这是【填空题】的示例，请填写中国四大名著：_____、_____、_____、_____。&#10;'
      iinitVal += '答案：红楼梦，三国演义，西游记，水浒传 &#10;'
      iinitVal += '解析： &#10;'
      iinitVal += '规则一.题干存在（ ）这种闭合括号，或者 _____ 五个连续英文下划线&#10;'
      iinitVal += '规则二.多个填空的答案可以用(，或、)分开 &#10;'
      iinitVal += '&#10;'
      iinitVal += '4.这是【判断题】的示例，考试云可以支持批量导入？ &#10;'
      iinitVal += '答案：正确 &#10;'
      iinitVal += '解析：&#10;'
      iinitVal += '规则一.答案为（正确、错误、错、是、不是、对、不对）这些 &#10;'
      iinitVal += '&#10;'
      iinitVal += '5.这是【简答题】的示例，考试云中批量导入在哪个目录？ &#10;'
      iinitVal += '答案：试题库-->添加试题-->批量导入 &#10;'
      iinitVal += '解析：&#10;'
      iinitVal += '规则一.如果不是以上这些题型，则默认为简答题 &#10;'
      iinitVal += '&#10;'
      document.getElementById('textQuestions').innerHTML = iinitVal
    },
    addDemo () {
      const textQuestions = document.getElementById('textQuestions').value
      if (textQuestions && textQuestions.length > 0) {
        this.$confirm('输入区域已有内容，是否清空？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.showTextarea = false
          this.$nextTick(() => {
            this.showTextarea = true
            this.$nextTick(() => {
              this.questionsList = []
              this.errorList = []
              this.checkAll = false
              this.flObj = {}
              this.defaultNycd = null
              this.demo()
            })
          })
        }).catch(() => {})
      } else {
        this.showTextarea = false
        this.$nextTick(() => {
          this.showTextarea = true
          this.$nextTick(() => {
            this.questionsList = []
            this.errorList = []
            this.checkAll = false
            this.flObj = {}
            this.defaultNycd = null
            this.demo()
          })
        })
      }
    }
  }
}
</script>
<style lang="less">
  /* 隐藏滚动条 */
  body::-webkit-scrollbar {
    width: 10px;
    color: transparent;
  }
</style>

<style lang="less" scoped>
.user-textarea-01::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999;
  font-size: 13px;
}

.user-textarea-01 {
  margin: 0 auto;
  border: none;
  max-width: 99%;
  min-width: 99%;
  width: 400px;
  // width: 100%;
  height: 100%;
  color: #2c3e50;
  font-size: 14px;
  vertical-align: top; // 解决textarea 下面多余的空间

  border: 1px solid #dcd5d5;
  box-shadow: 0 0 .8px #719ECE;
  border-radius: 4px;

  &::placeholder{
    font-size: 14px;
  }

  &:focus {
    outline: none !important;
    border: 1px solid #dcd5d5;
    border-radius: 4px;
    box-shadow: 0 0 3px #719ECE;
  }
}
</style>
